import InfoIcon from '@mui/icons-material/Info';
import { Tooltip, type TooltipProps } from '@mui/material';
import { useMemo } from 'react';

type InfoTooltipProps = Omit<TooltipProps, 'children'> & { disabled?: boolean };

export const InfoTooltip = (props: InfoTooltipProps) => {
  // If the tooltip is disabled, we want to disable all interactions with it
  const disabled: Omit<TooltipProps, 'children' | 'title'> | null = useMemo(() => {
    if (!props?.disabled) return null;

    return {
      open: false,
      disableFocusListener: true,
      disableHoverListener: true,
      disableTouchListener: true,
    } as Omit<TooltipProps, 'children' | 'title'>;
  }, [props?.disabled]);

  return (
    <Tooltip enterDelay={300} {...props} {...disabled}>
      <InfoIcon />
    </Tooltip>
  );
};
